import React, { useState } from "react";
import { cx } from "class-variance-authority";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../Popover/Popover";
import { useTooltipVisibility } from "./TooltipVisibilityContext";
import * as styles from "./Tooltip.module.scss";

const Tooltip = ({
  trigger,
  content,
  side = "top",
  showArrow = true,
  contentClassName,
  arrowClassName,
}: {
  trigger: React.ReactNode;
  content: React.ReactNode;
  side?: "top" | "bottom";
  showArrow?: boolean;
  contentClassName?: string;
  arrowClassName?: string;
}) => {
  const isParentVisible = useTooltipVisibility();
  const [isOpen, setIsOpen] = useState(false);

  const handleMouseEnter = () => {
    setIsOpen(true);
  };
  const handleMouseLeave = () => {
    setIsOpen(false);
  };

  return (
    <Popover open={isParentVisible && isOpen}>
      <PopoverTrigger
        asChild
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {trigger}
      </PopoverTrigger>
      <PopoverContent
        side={side}
        className={cx(styles.tooltipContent, contentClassName)}
        showArrow={showArrow}
        arrowClassName={cx(styles.arrowTooltip, arrowClassName)}
      >
        {content}
      </PopoverContent>
    </Popover>
  );
};

export { Tooltip };
